module.exports = __webpack_public_path__ + "static/media/SmartShop_3-568w.92c9db36.png";